<template>
    <BreadCrumb PageTitle="Liste des genres" />
    <ListeGenre />
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import ListeGenre from "../../components/Genre/ListeGenre.vue";

  export default defineComponent({
    name: "ListeGenrePage",
    components: {
      BreadCrumb,
      ListeGenre,
    },
  });
  </script>